import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { getAllItems } from "@/lib/library-store";
import { useTheme } from "@/lib/theme-context";

type Search = { type?: "movie" | "series" };

export const Route = createFileRoute("/random")({
  validateSearch: (s: Record<string, unknown>): Search => {
    const t = typeof s.type === "string" ? s.type : undefined;
    return t === "movie" || t === "series" ? { type: t } : {};
  },
  head: () => ({
    meta: [
      { title: "عشوائي — Rawan UI" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: RandomPage,
});

function RandomPage() {
  const { type } = Route.useSearch();
  const navigate = useNavigate();
  const { language } = useTheme();
  const t = (ar: string, en: string, fr: string) =>
    language === "ar" ? ar : language === "fr" ? fr : en;

  useEffect(() => {
    const all = getAllItems().filter((m) => !type || m.type === type);
    if (all.length === 0) {
      navigate({ to: "/movies", replace: true });
      return;
    }
    const pick = all[Math.floor(Math.random() * all.length)];
    navigate({
      to: pick.type === "series" ? "/series/$slug" : "/movie/$slug",
      params: { slug: pick.slug },
      replace: true,
    });
  }, [type, navigate]);

  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 text-center">
        <p className="text-lg font-semibold mb-2">
          {t("جارٍ اختيار عنوان عشوائي…", "Picking a random title…", "Sélection aléatoire…")}
        </p>
        <p className="text-sm text-muted-foreground">
          <Link to="/movies" className="underline">
            {t("العودة إلى الأفلام", "Back to movies", "Retour aux films")}
          </Link>
        </p>
      </main>
      <Footer />
    </div>
  );
}
